import { Box, Icon, Text } from '@customerio/pluma-components/react';
import clsx from 'clsx';
import * as styles from './index.css';

interface RocketFloatingButtonProps {
  onClick: () => void;
  hasConfig: boolean;
  completedSteps?: number;
  totalSteps?: number;
}

export function RocketFloatingButton({ onClick, hasConfig, completedSteps, totalSteps }: RocketFloatingButtonProps) {
  return (
    <Box
      as="button"
      display="flex"
      alignItems="center"
      justifyContent="flex-start"
      pl="100"
      onClick={onClick}
      className={clsx(styles.rocketButton, {
        [styles.rocketButtonHasConfig]: hasConfig,
      })}
      data-tourtip-target="rocket-button"
    >
      <Icon name="feature-launch" size="lg" mr="050" />
      {hasConfig && completedSteps != null && totalSteps != null ? (
        <Text size="m" weight="semibold" color="invert">
          {completedSteps}/{totalSteps}
        </Text>
      ) : null}
    </Box>
  );
}
